import { Axios } from 'axios'
import { RootState } from '@/store'
import { Kamoku, ShokushuKmkTypeType, ShokushuTypeType } from '@/repositories/keiei-joho/data'
import { ResponseShokushuSetting, ResponseShokushuSettingItem } from '@/repositories/keiei-joho/shokushu/data'

type PostParamItem = {
  kmkType: ShokushuKmkTypeType;
  settings: Kamoku[];
}

export interface ShokushuSettingRepository {
  list (): Promise<ResponseShokushuSetting>;
  save (postParam: ResponseShokushuSettingItem[]): Promise<void>;
}

export class ShokushuSettingRepositoryImpl implements ShokushuSettingRepository {
  constructor (http: Axios, baseUrl: string, state: RootState) {
    this.http = http
    this.baseUrl = `${baseUrl}/shokushu/setting`
    this.state = state
  }

  private readonly http: Axios

  private readonly baseUrl: string

  private readonly state: RootState

  async list (): Promise<ResponseShokushuSetting> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate

    const { data } = await this.http.get(
      this.baseUrl,
      {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      }
    )
    return data
  }

  async save (params: ResponseShokushuSettingItem[]): Promise<void> {
    const postParam: PostParamItem[] = params.map(p => ({
      kmkType: p.kmkType,
      settings: p.setting.targets
    }))
    await this.http.post(this.baseUrl, postParam)
  }
}
